import Vue from "vue";
import hotGamePushVue from "./hotGamePush.vue";
import hotGamePushVueVertical from "./hotGamePushVertical.vue";
import merge from "@/utils/merge";

const defaults = {
    data: [],
    expand: false,
};

const HotGamePush = (options) => {
    options = merge({}, defaults, options);
    const HotGamePushConstructor = Vue.extend(
        options.vertical ? hotGamePushVueVertical : hotGamePushVue
    );
    HotGamePushConstructor.prototype.close = function() {
        if (this._instance != null) {
            this._instance.reset();
        }
        if (this._vm != null) {
            this._vm = null; //让GC回收
        }
    };
    let instance = new HotGamePushConstructor({
        data: options,
    });
    instance._vm = instance.$mount();
    instance._el = instance.$el;
    instance._instance = instance;
    document.body.appendChild(instance.$el); // 把生成的提示的dom插入body中
    return instance;
};

export default HotGamePush;